import React from 'react'
import { BillingPlanFragment } from '@sketch/gql-types'

// Local Components
import Card from './components/Card'

// Styles
import { PlansWrapper } from './PlanPicker.styles'

// Types
interface PlansProps {
  isDisabled?: boolean
  selectedPlan?: BillingPlanFragment
  plans: BillingPlanFragment[]
  onChange: (clickedPlan: BillingPlanFragment) => void
}

/**
 * PlanPicker
 *
 * Renders cards with each sketch plan (Trial, Monthly, Yearly) detail
 * and allows the user to select one of them.
 *
 * Trial can be hidden for certain users using the showTrial flag
 *
 * @example
 * <PlanPicker onChange={(clickedPlan) => {...}} />
 *
 */
export const PlanPicker: React.FC<PlansProps> = ({
  isDisabled = false,
  onChange,
  selectedPlan,
  plans,
}) => (
  <PlansWrapper>
    {plans.map(plan => (
      <Card
        key={plan.id}
        onChange={onChange}
        plan={plan}
        isSelected={plan.id === selectedPlan?.id}
        isDisabled={isDisabled}
      />
    ))}
  </PlansWrapper>
)
